(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./ModernBoardKey.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./ModernBoardKey.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.ModernBoardKey);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _ModernBoardKey) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _vm.noTouch ? _c('div', {
        class: ['modern-key', 'no-touch', _vm.active ? 'active' : '', _vm.hideContent ? 'no-dot' : ''],
        on: {
          "click": _vm.onFocus
        }
      }, [_vm.$slots.default && !_vm.hideContent ? _vm._t("default") : _vm._e(), !_vm.$slots.default && !_vm.hideContent ? _c('div', {
        attrs: {
          "aria-label": _vm.ariaKeyDelete ? _vm.value + "，点按两次即可输入" : '删除'
        }
      }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")]) : _vm._e()], 2) : _c('div', {
        class: ['modern-key', _vm.active ? 'active' : ''],
        on: {
          "click": _vm.onFocus
        }
      }, [_vm.$slots.default && !_vm.hideContent ? _vm._t("default") : _vm._e(), !_vm.$slots.default && !_vm.hideContent ? _c('div', {
        attrs: {
          "aria-label": _vm.ariaKeyDelete ? _vm.value + "，点按两次即可输入" : '删除'
        }
      }, [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")]) : _vm._e()], 2);
    },
    name: 'modern-key',
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      noTouch: {
        type: Boolean,
        default: false
      },
      noPrevent: {
        type: Boolean,
        default: false
      },
      hideContent: {
        type: Boolean,
        default: false
      },
      ariaKeyDelete: {
        type: Boolean,
        default: true
      }
    },
    data: function data() {
      return {
        active: false
      };
    },
    methods: {
      onFocus: function onFocus() {
        if (!this.noPrevent) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        if (!this.noTouch) {
          this.active = true;
        }

        this.$emit('press', this.value);
      },
      onBlur: function onBlur() {
        this.active = false;
      }
    }
  };
  _exports.default = _default;
});